import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import Offense from '../../models/offense';
import OffenseService from '../../services/offenseService';
import BrowserWindowObjectService from '../../services/browserWindowObjectService';
import ComplianceAuditLogService from '../../services/complianceAuditLogService';
import FormControl from '../../models/formControl';
import ComplianceAuditLog from '../../models/complianceAuditLog';

@Component({
  selector: 'app-offense-search',
  templateUrl: './offenseSearch.component.html',
  styleUrls: ['./offenseSearch.component.scss'],
  providers: []
})

export default class OffenseSearchComponent implements OnInit {

  constructor(private offenseService: OffenseService,
    private complianceAuditLogService: ComplianceAuditLogService,
    private router: Router,
    private browserWindowObjectService: BrowserWindowObjectService) { }

  ngOnInit() {
  }

  @Input() set offenseObject(offense: Offense) {
    if (offense) {
      this.offense = offense;
    }
  }

  @Input() set offenseSearchFormGroupObject(offenseSearchFormGroup: FormGroup) {
    this.offenseSearchFormGroup = offenseSearchFormGroup;
    this.formControl = new FormControl(this.offenseSearchFormGroup);
  }

  async workOrderComplete() {
    try {

      const admittedCrimeNotFound = this.formControl.getBooleanByControlName('admittedCrimeNotFound');

      if (admittedCrimeNotFound) {
        await this.complianceAuditLogService.addComplianceAuditLogs([
          new ComplianceAuditLog(this.offense.offenseSearch.requestNumber, 'ADMTTD_CRM_NOT_FND', 'OFFENCEPG', null, null)
        ]);
      }

      this.offenseService.workOrderComplete(this.offense.offenseSearch.requestNumber, admittedCrimeNotFound)
      .subscribe((object: any) => {
        if (object === null) {
          this.router.navigate(['navigation']);
        }
      });
    } catch (e) {
      // If it's in here an exception happened when writing to
      // the compliance audit log.
      // Don't want to work order complete if that happens.
    }
  }

  goBackToTaskList() {
    this.browserWindowObjectService.goBackOnePage();
  }

  get admittedCrimeNotFound() { return this.offenseSearchFormGroup.get('admittedCrimeNotFound'); }

  offense: Offense;
  @Input() canWorkOrderComplete = false;
  @Input() offensePageForm: FormGroup;
  public offenseSearchFormGroup: FormGroup;
  private formControl: FormControl;
 }



// WEBPACK FOOTER //
// ./src/app/offenseSearch/offenseSearch.component.ts